import React from 'react';
import { Card, Grid, Icon, Page } from 'tabler-react';
import RemoveLastDirectoryPartOf from '../goBackButton';

function dateformat(dateStr) {
    const dateParts = dateStr.split("-"); // Split the string into day, month, and year parts
    const year = dateParts[2];
    const month = dateParts[1];
    const day = dateParts[0];
    
    const formattedDate = new Date(`${month}/${day}/${year}`);
    const options = { weekday: 'short', day: '2-digit', month: 'short' };
    const formattedDateString = formattedDate.toLocaleDateString('en-UK', options);

    return formattedDateString;

}

class PsAttendance extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            postId: null,
            session: null
        };
    }
    checkResponse(data) {
        this.setState({
            data: data,
            session: data.attendance.dayobjects[0]
        });
    }

    async componentDidMount() {
        const rollno = localStorage.getItem('htno');
        let res = await fetch(`http://projectschool.kmitonline.com/getPsAttendanceForSanjaya/${rollno}`,{
            method: 'GET',
        });
        const result = await res.json();
        this.checkResponse(result)
      }

    render() {
        let dailyatt, day, last2weeks;
        if (this.state.session == null) {
            dailyatt = <NoAttendance />;
            last2weeks = dailyatt;
            day = '--';
        } else {
            dailyatt = <AttendanceCard data={this.state.session} />;
            last2weeks = [];
            for (
                var i = 1;
                i < this.state.data.attendance.dayobjects.length;
                i++
            ) {
                last2weeks.push(
                    <TwoWeeksAttendanceCard
                        data={this.state.data.attendance.dayobjects[i]}
                    />
                );
            }
            last2weeks.push(
                <table className="mt-2" style={{ width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ textAlign: 'right' }}>
                                <DayAttendance data="1"></DayAttendance>
                            </td>
                            <td>
                                {
                                    this.state.data.attendance.twoweeksessions
                                        .present
                                }
                            </td>
                            <td style={{ textAlign: 'right' }}>
                                <DayAttendance data="0"></DayAttendance>
                            </td>
                            <td>
                                {
                                    this.state.data.attendance.twoweeksessions
                                        .absent
                                }
                            </td>
                            <td style={{ textAlign: 'right' }}>
                                <DayAttendance data="2"></DayAttendance>
                            </td>
                            <td>
                                {
                                    this.state.data.attendance.twoweeksessions
                                        .nosessions
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
            );
            day = 'Today'
        }

        let a1 = <Card.Body>{dailyatt}</Card.Body>;        
        let a2 = <Card.Body>{last2weeks}</Card.Body>;
        return (
            <Page.Content className="attendance">
                <div
                    className="m-2"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Attendance</div>
                </div>
                <Grid.Row>
                    <Grid.Col xs={12} sm={12} md={12} xl={12}>
                        <Card isCollapsible title={day} body={a1} />
                    </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Col xs={12} sm={12} md={12} xl={12}>
                        <Card
                            isCollapsible
                            isCollapsed
                            title="Last 2 Weeks"
                            body={a2}
                        />
                    </Grid.Col>
                </Grid.Row>
            </Page.Content>
        );
    }
}

class NoAttendance extends React.Component {
    render() {
        return <div>No attendance available</div>;
    }
}

class AttendanceCard extends React.Component {
    render() {
        // console.log(this.props.data, '&$$');
        if (this.props.data) {
            return (
                <div>
                    <DayAttendance data={this.props.data.sessions.session1} />
                    <DayAttendance data={this.props.data.sessions.session2} />
                    <DayAttendance data={this.props.data.sessions.session3} />
                    <DayAttendance data={this.props.data.sessions.session4} />
                    <DayAttendance data={this.props.data.sessions.session5} />
                    <DayAttendance data={this.props.data.sessions.session6} />
                    <DayAttendance data={this.props.data.sessions.session7} />
                    <div>{dateformat(this.props.data.date)}</div>
                </div>
            );
        } else {
            // console.log(this.props, '%');
            return <div>No attendance.</div>;
        }
    }
}

class TwoWeeksAttendanceCard extends React.Component {
    render() {
        // console.log(this.props.data, '&$$');
        if (this.props.data) {
            return (
                <div>
                    <table style={{ width: '100%' }}>
                        <tbody>
                            <tr>
                                <td style={{ width: '50%' }}>
                                    {dateformat(this.props.data.date)}
                                </td>
                                <td>
                                    <DayAttendance
                                        data={this.props.data.sessions.session1}
                                    />
                                    <DayAttendance
                                        data={this.props.data.sessions.session2}
                                    />
                                    <DayAttendance
                                        data={this.props.data.sessions.session3}
                                    />
                                    <DayAttendance
                                        data={this.props.data.sessions.session4}
                                    />
                                    <DayAttendance
                                        data={this.props.data.sessions.session5}
                                    />
                                    <DayAttendance
                                        data={this.props.data.sessions.session6}
                                    />
                                    <DayAttendance
                                        data={this.props.data.sessions.session7}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
        } else {
            return <div>No attendance.</div>;
        }
    }
}

class DayAttendance extends React.Component {
    render() {
        // console.log(this.props.data);
        switch (this.props.data) {
            case "0":
                return (
                    <Icon prefix="fe" name="x-circle" className="red"></Icon>
                );
            case "1":
                return (
                    <Icon prefix="fe" name="check-circle" className="green" />
                );
            case "2":
                return <Icon prefix="fe" name="circle" />;
            default:
                return <Icon prefix="fe" name="circle" />;
        }
    }
}

export default PsAttendance;
